import './App.css';
import {
	BrowserRouter,
	Navigate,
	Outlet,
	Route,
	Routes,
} from 'react-router-dom';
import { getAccessToken } from './Utils/AuthUtil';
import Login from './pages/Login';
import ChatHistoryList from './pages/ChatHistory';
import ChatLeads from './pages/ChatLeads';

function App() {
	return (
		<>
			<BrowserRouter>
				<Routes>
					<Route element={<AuthenticationRoutes />}>
						<Route path="/" element={<Login />} />
					</Route>
					<Route element={<PrivateRoutes />}>
						<Route
							path="/chatHistory"
							element={<ChatHistoryList />}
						/>
						<Route path="/chatLeads" element={<ChatLeads />} />
					</Route>
				</Routes>
			</BrowserRouter>
		</>
	);
}

function PrivateRoutes() {
	return getAccessToken() ? <Outlet /> : <Navigate to="/" />;
}

function AuthenticationRoutes() {
	return getAccessToken() ? <Navigate to="/chatHistory" /> : <Outlet />;
}

export default App;
